(() => {
  const input = document.querySelector('#search-input');
  const dropdown = document.querySelector('.autocomplete-list');
  const frequentSearch = document.querySelector('.frequent-search');
  let timer;

  if (!input || !dropdown || !frequentSearch) {
    return;
  }

  input.addEventListener('input', () => {
    clearTimeout(timer);

    if (input.value.length > 0) {
      frequentSearch.classList.add('d-none');
    } else {
      frequentSearch.classList.remove('d-none');
    }

    const query = input.value.trim();

    if (query.length < 2) {
      dropdown.innerHTML = '';
      return;
    }

    timer = setTimeout(() => {
      fetch(`${window.location.origin}/wp-json/autocomplete/v1/search?q=` + encodeURIComponent(query))
        .then(response => {
          if (!response.ok) {
            throw new Error(`Erreur HTTP ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          dropdown.innerHTML = '';
          if (data && data.length > 0) {
            frequentSearch.classList.add('d-none');
            for (const item of data) {
              const li = document.createElement('li');
              li.innerHTML = `<a href="${item.url}">
                <span class='btn btn-light btn-circle'>
                  <svg class='svg-arrow-top-right-dims' aria-hidden='true'>
                    <use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='/wp-content/themes/irts/dist/images/sprite.symbol.svg#arrow-top-right'></use>
                  </svg>
                </span>
                ${item.title}
              </a>`;
              dropdown.append(li);
            }
          } else {
            const li = document.createElement('li');
            li.textContent = 'Aucun résultat trouvé';
            li.classList.add('no-results');
            dropdown.append(li);
          }
        })
        .catch(() => {
          dropdown.innerHTML = '';
          const li = document.createElement('li');
          li.textContent = 'Une erreur est survenue. Veuillez réessayer.';
          li.classList.add('error');
          dropdown.append(li);
        });
    }, 200);


    if (input.value.length === 0) {
      frequentSearch.classList.remove('d-none');
    }
  });

  document.addEventListener('click', event_ => {
    if (!input.contains(event_.target)) {
      dropdown.innerHTML = '';
    }
  });

})();
